@import "../common/styles.scss";
@import "../../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";
@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  --pill-border-radius: 12px;
  --pill-padding-inline: var(--spacing-padding-m);
  --pill-padding-block: var(--spacing-padding-xxs);
  --pill-font-size: var(--font-size-body-s);

  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: max-content max-content 1fr;
}
$header-item-common-inline-padding: var(--spacing-padding-xxl);
$header-item-common-separator-border: 1px solid
  var(--color-border-surface-on-elevation-1);

%header-item-common-inline-sizes {
  max-inline-size: 250px;
  min-inline-size: 180px;
}
%header-item-common {
  padding-inline: $header-item-common-inline-padding;
  border-inline-end: $header-item-common-separator-border;
  @extend %header-item-common-inline-sizes;
}
%header-item-common-start {
  padding-inline-end: $header-item-common-inline-padding;
  border-inline-end: $header-item-common-separator-border;
}
%header-item-common-end {
  padding-inline-start: $header-item-common-inline-padding;
}

.section {
  display: contents;
}

.header {
  display: grid;
  gap: var(--spacing-gap-xxl);
}

// header detail
.header__detail {
  display: grid;
  grid-template-areas:
    "detail-title detail-title detail-title detail-title"
    // "detail-commit-name detail-commit-name detail-commit-name detail-commit-name"
    "detail-genexus-server detail-knowledge-base detail-current-version detail-merge-from-version";
  row-gap: var(--spacing-gap-xl);
  // grid-auto-columns: max-content;
  // grid-template-columns: max-content auto auto auto;
  // grid-template-columns: minmax(250px, 350px) repeat(3, minmax(180px, 250px));
}
.detail__label {
  color: var(--color-text-neutral-disabled);
}
.detail__title {
  grid-area: detail-title;
}
.detail__commit-name {
  grid-area: detail-commit-name;
}
.detail__genexus-server {
  grid-area: detail-genexus-server;
  @extend %header-item-common-start;

  > a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
}
.detail__link {
  align-items: start;
  color: var(--color-text-primary-default);
  text-decoration: underline;
  &:hover {
    color: var(--color-text-primary-hover);
  }
  &:active {
    color: var(--color-text-primary-pressed);
  }
}
.detail__knowledge-base {
  grid-area: detail-knowledge-base;
  @extend %header-item-common;
}
.detail__current-version {
  grid-area: detail-current-version;
  @extend %header-item-common;
}
.detail__merge-from-version {
  grid-area: detail-merge-from-version;
  @extend %header-item-common-end;
}

// header information
.header__information {
  display: grid;
  row-gap: var(--spacing-gap-m);
  grid-template-areas:
    "information-title information-title"
    "information-col-1 information-col-2";
  grid-template-columns: max-content 1fr;
  grid-template-rows: max-content max-content;
}
.information__title {
  grid-area: information-title;
}
.information__col-1 {
  grid-area: information-col-1;
  display: flex;
  gap: var(--spacing-gap-xxl);
  @extend %header-item-common-start;
}

//header comments
.header__comments .layout__panel {
  justify-items: start;
  text-align: left;
}

// filter / controls-container
.controls-container {
  display: grid;
  margin-block-start: var(--spacing-padding-xxl);
}
.filter {
  grid-template-columns: 232px 186px 1fr;
}
.button-merge-checked {
  margin-inline-start: auto;
}

// main
.main {
  position: relative;
  display: grid;
  overflow: auto;
}
.loader {
  position: relative;
  inline-size: 100%;
  block-size: 100%;
  inset-block-start: 0;
}
.tabular-grid {
  border-radius: 4px;
  overflow: hidden;
}

.empty-state {
  block-size: 100%;
}
.loader {
  --elevation-background-color: var(--color-accent-surface-elevation-1);
}

.tabular-grid.empty-result::part(main) {
  // WA to avoid scrollbar flickering when displaying the empty-state message
  overflow: hidden;
}

.comments-container {
  @include ellipsis;
}

.button-tertiary.edit-range-button {
  padding-block: 0;
  align-content: flex-end;
}

// - - - - - - - - - - - - - -
// WA (WORK AROUNDS)
// - - - - - - - - - - - - - -

.input-comments-container {
  position: relative;
}
// ch-edit for comments WA's
// Figma design for this component displays the textarea witout border, and with a little more line-height.
// The following styles are a temporary WA that should be brouhgt to Mercury DS.
.input-comments {
  --control-border-color: transparent;
  padding-block: 0 !important;
  padding-inline: 0 !important;
  --line-height-tight: 1.4;
  block-size: 100%;
  background-color: var(--color-accent-surface-surface);
  transition:
    var(--timing-super-fast) block-size,
    var(--timing-super-fast) background-color,
    var(--timing-super-fast) padding-block,
    var(--timing-super-fast) padding-inline;
}
.input-comments:focus {
  position: absolute;
  block-size: 200px;
  inline-size: 100%;
  z-index: 99;
  background-color: var(--color-accent-surface-elevation-1);
  padding-block: var(--control-padding-block) !important;
  padding-inline: var(--control-padding-inline) !important;
}

ch-tabular-grid-cell.tabular-grid-cell::part(actions-icon) {
  background-size: contain; //force icon fit container
  margin-inline-end: 0;
  --icon-path: var(--icon__gemini-tools_show-more-vertical_neutral--enabled);
  cursor: pointer;
  &:hover {
    --icon-path: var(--icon__gemini-tools_show-more-vertical_neutral--hover);
  }
  &:active {
    --icon-path: var(--icon__gemini-tools_show-more-vertical_neutral--active);
  }
}

.tabular-grid-row-actions::part(main),
.property-grid-row-actions::part(main) {
  // gap not required since buttons are tertiary.
  // extra space perceived.
  gap: 0 !important;
}

.tabular-grid-row-actions {
  // Butons are center by default, but design dictates start alignemnt
  > button {
    justify-content: start;
  }
}

// These static type of pills do not exist on Mercury yet.
// They should be defined on Mercury. The actual pills on Mercury
// are combo-boxes. Not what we need for this case.

.pill {
  --pill-background-color: transparent;
  --pill-color: transparent;
  --pill-border-color: transparent;

  background-color: var(--pill-background-color);
  color: var(--pill-color);
  border: 1px solid var(--pill-border-color);
  inline-size: 100%;
  padding: var(--pill-padding-block) var(--pill-padding-inline);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--pill-border-radius);
  position: relative;

  &--to-merge,
  &--to-revert {
    --pill-background-color: var(--color-accent-neutral-contrast);
    --pill-color: var(--color-border-primary-default);
    --pill-border-color: var(--color-accent-primary-pressed);
  }
  &--to-merge-marked {
    --pill-background-color: var();
    --pill-color: var(--color-border-primary-default);
    --pill-border-color: var();
  }
  &--pending {
    --pill-background-color: var(--color-accent-neutral-contrast);
    --pill-color: var(--color-border-primary-default);
    --pill-border-color: var(--color-accent-primary-pressed);
  }
  &--warning {
    --pill-background-color: var(--color-accent-warning-contrast);
    --pill-color: var(--color-border-warning-default);
    --pill-border-color: var(--color-border-warning-default);
  }
  &--error {
    --pill-background-color: var(--color-accent-error-contrast);
    --pill-color: var(--color-border-error-default);
    --pill-border-color: var(--color-border-error-light);
  }
  &--merged,
  &--reverted {
    --pill-background-color: var(--color-accent-success-contrast);
    --pill-color: var(--color-border-success-default);
    --pill-border-color: var(--color-accent-success-default);
  }
  &--transitioning {
    // used to hide the text, before updating the caption (smooth transtion)
    --pill-color: transparent;
  }
}
.merging-spinner-caption {
  display: flex;
  align-items: center;
  gap: var(--spacing-gap-m);
  $size: 16px;
  --status-circle-color: transparent;
  --status-circle-size: $size;
  --status-circle-inset-inline-start: 16px;
  --pill-color: var(--color-border-primary-default);
  &::before {
    display: inline-block;
    content: "";

    @include spinner(
      $size,
      var(--color-accent-primary-default),
      var(--color-accent-primary-pressed)
    );
  }
}
.tabular-grid .button-secondary {
  --control-padding-block: var(--pill-padding-block);
  --control-padding-inline: var(--pill-padding-inline);
  font-size: inherit;
  font-weight: inherit;
  /* font-size: var(--pill-font-size); */
}

.tabular-grid .tabular-grid-cell--for-pill {
  padding-block: 0;
  align-items: center;
  justify-content: center;
}

.tabular-grid.disabled-custom-selector .tabular-grid-cell::part(selector-label),
.tabular-grid.disabled-custom-selector .tabular-grid-column::part(bar-selector),
.tabular-grid.disabled-custom-selector .tabular-grid-cell::part(actions-icon) {
  pointer-events: none;
  opacity: 0.5;
}
.tabular-grid-column--settings-custom-selector,
.tabular-grid-cell--settings-custom-selector {
  padding: 0;
}
.tabular-grid-cell::part(actions-icon) {
  padding-block: var(--spacing-padding-m);
}
ch-tabular-grid-cell.tabular-grid-cell::part(actions-icon) {
  block-size: 100%;
  display: block;
  background-size: 16px;
  padding-inline: var(--spacing-padding-xl);
}

.tabular-grid-cell.no-checkbox-custom-selector::part(selector-label) {
  visibility: hidden;
}

.tabular-grid-row-actions::part(window) {
  background-color: var(--color-accent-surface-elevation-2) !important;
}

.tabular-grid-row .tabular-grid-cell:nth-child(3) {
  min-inline-size: 400px;
}

// - - - - - - - - - - - - - -
// END OF WA
// - - - - - - - - - - - - - -
